import script from "./review.vue?vue&type=script&setup=true&lang=js"
export * from "./review.vue?vue&type=script&setup=true&lang=js"

import "./review.vue?vue&type=style&index=0&id=444e9b3a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-444e9b3a"]])

export default __exports__